import React, { FC } from "react";
import { useGetN400PayFail } from "../../../../hooks/n400/useN400";
import PayFail from "../../components/PayFail";

interface Props {
  onRetry: () => void;
  isRetrying: boolean;
}

const N400PayFail: FC<Props> = ({ onRetry, isRetrying }) => {
  const { isLoading, isError } = useGetN400PayFail();

  return (
    <PayFail
      onRetry={onRetry}
      isRetrying={isRetrying}
      isLoading={isLoading}
      isError={isError}
    />
  );
};

export default N400PayFail;
